import { Warehouse } from 'src/types/Warehouse';
import { cache } from 'src/utils/cache';
import api from './Api';
import { Vendor } from 'src/types/vendor';
import VendorApi from './VendorApi';
import itemApi from './ItemApi';
import { OrderEntry } from 'src/types/orderEntry';
import orderApi from './OrderApi';
import { ItemSearchRequest } from 'src/types/itemSearchRequest';
import { HistoricalQuantity } from 'src/types/historicalQuantity';
import { OrderSummary } from 'src/types/orderSummary';
import { getOrderItemPricingRequest } from 'src/types/getOrderItemPricingRequest';
import { OrderItemPricing } from 'src/types/orderItemPricing';
import { DeliveryMethod, Term, TermType } from 'src/types/orderHeaderDropdowns';

// --- Warehouses ---
const fetchAllWarehouses = (): Promise<Warehouse[]> => {
  return api.get<Warehouse[]>('/sfa/warehouses');
};
export const getAllWarehouses = cache(fetchAllWarehouses);

// --- Term Types ---
const fetchTermTypes = (): Promise<TermType[]> => {
  return orderApi.getTermTypes();
};
export const getCachedTermTypes = cache(fetchTermTypes);

// --- Terms ---
const fetchVendorDirectTerms = (termCode: string, vendorNumber: number): Promise<Term[]> => {
  return orderApi.getVendorDirectTerms(termCode, vendorNumber);
};
export const getCachedVendorDirectTerms = cache(fetchVendorDirectTerms);

const fetchWarehouseTerms = (termCode: string, sfaOrderId: number): Promise<Term[]> => {
  return orderApi.getWarehouseTerms(termCode, sfaOrderId);
};
export const getCachedWarehouseTerms = cache(fetchWarehouseTerms);

// --- Vendors ---
const fetchVendorByNumber = async (vendorNumber: string): Promise<Vendor | null> => {
  const odataResponse = await VendorApi.getVendorByNumber(vendorNumber);
  if (odataResponse.value && odataResponse.value.length > 0) {
    return odataResponse.value[0];
  }
  return null;
};
export const getVendorByNumber = cache(fetchVendorByNumber);


// --- Item History ---
const fetchCustomItemHistory = (request: ItemSearchRequest): Promise<HistoricalQuantity[]> => {
  return itemApi.getCustomItemHistory(request);
};
export const getCustomItemHistory = cache(fetchCustomItemHistory);

// --- Order Summary ---
const fetchOrderSummary = (orderId: number, customerNumber: number, total: number, orderItemsCount: number): Promise<OrderSummary | null> => {
  //total is used to break the cache when order total changes
  return orderApi.getOrderSummary(orderId, customerNumber);
};

export const getCachedOrderSummary = cache(fetchOrderSummary);

// --- Order Item Pricing ---
const fetchOrderItemPricing = async (request: getOrderItemPricingRequest): Promise<OrderItemPricing> => {
  // Pause for 1 second
  // await new Promise((resolve) => setTimeout(resolve, 2000));
  return orderApi.getOrderItemPricing(request);
};
export const getCachedOrderItemPricing = cache(fetchOrderItemPricing);

// -- Delivery Methods ---
const fetchDeliveryMethods = (sfaOrderId: number, shipToNumber: string, customerNumber: number): Promise<DeliveryMethod[]> => {
  return api.get<DeliveryMethod[]>(
    `/sfa/deliverymethods/?sfaOrderId=${encodeURIComponent(sfaOrderId)}&shipToNumber=${encodeURIComponent(shipToNumber)}&customerNumber=${encodeURIComponent(customerNumber)}`
  );
};
export const getCachedDeliveryMethods = cache(fetchDeliveryMethods);